import { Link } from "@tanstack/react-router";
import { ShieldCheck, BadgeCheck, Truck, Lock } from "lucide-react";

/** Buyer trust strip — links only to existing legal pages. */
export function TrustStrip() {
  const items = [
    { icon: Lock, label: "Secure payments", href: "/legal/buyer-terms" as const },
    { icon: BadgeCheck, label: "Verified sellers", href: "/legal/seller-agreement" as const },
    { icon: ShieldCheck, label: "Buyer protection", href: "/legal/refunds" as const },
    { icon: Truck, label: "Tracked delivery", href: "/legal/buyer-terms" as const },
  ];
  return (
    <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
      {items.map(({ icon: Icon, label, href }) => (
        <Link
          key={label}
          to={href}
          className="group flex items-center gap-2 rounded-xl border border-border/60 bg-surface-2/60 px-3 py-2.5 text-xs text-muted-foreground transition-colors hover:border-primary/40 hover:text-foreground"
        >
          <Icon className="h-4 w-4 text-primary/80 group-hover:text-primary transition-colors" />
          <span className="truncate">{label}</span>
        </Link>
      ))}
    </div>
  );
}
